import { IconButton } from '@mui/material';
import { TrashIcon } from '@phosphor-icons/react';

import { useReactFlowViewContext } from '../../../../context/context';

interface DeleteDecorationToolbarButtonProps {
  nodeId: string;
}

export function DeleteDecorationToolbarButton(props: DeleteDecorationToolbarButtonProps) {
  const { nodeId } = props;
  const { reactFlowMutators } = useReactFlowViewContext();
  return (
    <IconButton
      aria-label="Delete"
      size="small"
      onClick={() => reactFlowMutators?.deleteNode(nodeId)}
    >
      <TrashIcon />
    </IconButton>
  );
}
